import React from 'react';
import { ReactComponent as Clipboard } from 'assets/icons/ui-elements/small/clipboard-sm.svg';
import { ReactComponent as User } from 'assets/icons/ui-elements/small/user-sm.svg';
import { ReactComponent as House } from 'assets/icons/ui-elements/small/house-sm.svg';
import { ReactComponent as Building } from 'assets/icons/building.svg';
import { ReactComponent as DownIcon } from 'assets/icons/ui-elements/small/caret-down-sm.svg';
import {
  FiltersContainer,
  TypeFilterContainer,
  TypeButton,
  OpenModalButton,
  FiltersGridWrapper,
  FilterCell,
  FiltersGridColumn,
  UnidadesFieldWrapper,
} from '../styled';
import { MultiSelectDropdown } from 'newComponents/Form/Multiselect';
import { EventType } from '../../../hooks/useCalendarFilters';

interface CalendarFiltersProps {
  type: EventType;
  onTypeChange: (type: EventType) => void;
  onOpenExecutoresModal: () => void;
  onOpenAmbientesModal: () => void;
  onOpenPlanosModal: () => void;
  planosSelectionLabel: string;
  executoresSetoresSelectionLabel: string;
  ambientesEquipamentosSelectionLabel: string;
  maintenanceUnitsOptions: { label: string; value: string }[];
  maintenanceUnitsValues: string[];
  onMaintenanceUnitsChange: (values: unknown) => void;
}

export const CalendarFilters: React.FC<CalendarFiltersProps> = ({
  type,
  onTypeChange,
  onOpenExecutoresModal,
  onOpenAmbientesModal,
  onOpenPlanosModal,
  planosSelectionLabel,
  executoresSetoresSelectionLabel,
  ambientesEquipamentosSelectionLabel,
  maintenanceUnitsOptions,
  maintenanceUnitsValues,
  onMaintenanceUnitsChange,
}) => {
  return (
    <FiltersContainer>
      <TypeFilterContainer>
        <TypeButton isActive={type === 'pendentes'} onClick={() => onTypeChange('pendentes')} isRight={false}>
          Pendentes
        </TypeButton>
        <TypeButton isActive={type === 'baixadas'} onClick={() => onTypeChange('baixadas')} isRight={true}>
          Baixadas
        </TypeButton>
      </TypeFilterContainer>
      <FiltersGridWrapper>
        <FiltersGridColumn>
          <FilterCell>
            <UnidadesFieldWrapper>
              <MultiSelectDropdown
                options={maintenanceUnitsOptions}
                value={maintenanceUnitsValues}
                onChange={values => onMaintenanceUnitsChange(values as string[])}
                size="sm"
                width="100%"
                placeholder="Unidades"
                clearable
                searchable
                iconLeft={[<Building key="building-icon" />]}
              />
            </UnidadesFieldWrapper>
          </FilterCell>

          <FilterCell>
            <OpenModalButton onClick={onOpenExecutoresModal} width="100%" size="small">
              <div>
                <User /> Executores e Setores{executoresSetoresSelectionLabel}
              </div>
              <DownIcon />
            </OpenModalButton>
          </FilterCell>
        </FiltersGridColumn>

        <FiltersGridColumn>
          <FilterCell>
            <OpenModalButton onClick={onOpenPlanosModal} width="100%" size="small">
              <div>
                <Clipboard /> Planos{planosSelectionLabel}
              </div>
              <DownIcon />
            </OpenModalButton>
          </FilterCell>
          <FilterCell>
            <OpenModalButton onClick={onOpenAmbientesModal} width="100%" size="small">
              <div>
                <House /> Ambientes e Equipamentos{ambientesEquipamentosSelectionLabel}
              </div>
              <DownIcon />
            </OpenModalButton>
          </FilterCell>
        </FiltersGridColumn>
      </FiltersGridWrapper>
    </FiltersContainer>
  );
};
